import { spring as springEasing } from "animejs";

export const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

export const duration = {
  instant: 120,
  fast: 220,
  base: 380,
  slow: 680,
  slower: 1100
} as const;

export const ease = {
  standard: "out(3)",
  enter: "outExpo",
  exit: "in(2)",
  inOut: "inOut(3)",
  linear: "linear"
} as const;

export const spring = {
  snappy: springEasing({ stiffness: 260, damping: 20 }),
  gentle: springEasing({ stiffness: 120, damping: 16 }),
  bouncy: springEasing({ stiffness: 200, damping: 10 })
} as const;

export const staggerStep = {
  tight: 28,
  base: 60,
  loose: 110
} as const;

export const distance = {
  sm: 8,
  md: 16,
  lg: 32
} as const;

export const blur = {
  sm: 4,
  md: 10
} as const;

export function prefersReducedMotion() {
  return typeof window !== "undefined" && window.matchMedia(REDUCED_MOTION_QUERY).matches;
}
